import React, { FC } from 'react'

import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import Price from '@models/commerce/Price'

interface Props {
  price: Price
  className: string
}

const PriceInfo: FC<Props> = ({ price, className }) => {
  const { t } = useTranslation()
  return (
    <div className={classNames('flex text-md', className)}>
      <div className="flex flex-col mr-2">
        <p>{t('content.subtotal')}</p>
        <p>{t('content.tax')}</p>
        <p className="font-semibold">{t('content.total')}</p>
      </div>
      <div className="flex flex-col ml-2 text-right">
        <p>{price.getFormattedSubTotal()}</p>
        <p>{price.getFormattedTax()}</p>
        <p className="font-semibold">{price.getFormattedTotal()}</p>
      </div>
    </div>
  )
}
export default PriceInfo
